import PageListCtrl from '../PageListCtrl';
import newsfeedPagesManagementUrl from '../newsfeed-pages-management.html';

export default {
  templateUrl: newsfeedPagesManagementUrl,
  controller: PageListCtrl,
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
};
